import { createSlice } from "@reduxjs/toolkit";

import setAuthHeader from "../../utils/set-auth-header";

const initialState = {
  token: null,
  _id: null,
  name: null,
  email: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const { token, _id, name, email } = action.payload;
      state.token = token;
      state._id = _id;
      state.name = name;
      state.email = email;

      if (token) {
        localStorage.setItem("token", token);
        setAuthHeader(token);
      }
    },

    removeUser: (state, action) => {
      state._id = null;
      state.email = null;
      state.token = null;
      state.email = null;
      localStorage.removeItem("token");
      setAuthHeader();
    },
  },
});

export default userSlice.reducer;
export const { setUser, removeUser } = userSlice.actions;
